import { AnimatePresence } from "motion/react";
import React from "react";
import {
  FlowSolidButton,
  FlowSolidButtonGrey,
} from "../../components/FlowButtons";
import FlowContainer from "../../components/FlowContainer";
import CharactersLimit from "../components/CharactersLimit";
import {
  ReviewInfo,
  ReviewLabel,
  ReviewQuestionContainer,
  ReviewSection,
  ReviewTitle,
  TextAreaInputBox,
  TextInputBox,
} from "../components/ReviewStyledComponents";
import ProductHeader from "../components/ProductHeader";
import { FlowActionButtonsGroup } from "../../components/FlowStyledComponents";

export const TITLE_LENGTH_MIN = 20;
export const TITLE_LENGTH_MAX = 50;
export const REVIEW_LENGTH_MIN = 50;
export const REVIEW_LENGTH_MAX = 500;
export const REVIEW_LENGTH_MAX_AMAZON = 1000;

export const reviewLengthCheck = (
  title: string,
  review: string,
  maxLength = REVIEW_LENGTH_MAX
) => {
  if (title.length < TITLE_LENGTH_MIN || title.length > TITLE_LENGTH_MAX) {
    return false;
  }
  if (review.length < REVIEW_LENGTH_MIN || review.length > maxLength) {
    return false;
  }
  return true;
};

const LowRatingInput = ({
  product,
  reviewText,
  setReviewText,
  reviewTitle,
  setReviewTitle,
  moveNext,
  moveBack,
}: {
  product: any;
  reviewText: string;
  setReviewText: React.Dispatch<React.SetStateAction<string>>;
  reviewTitle: string;
  setReviewTitle: React.Dispatch<React.SetStateAction<string>>;
  moveNext: () => void;
  moveBack: () => void;
}) => {
  const maxReviewLength =
    product?.retailerId === 1 ? REVIEW_LENGTH_MAX_AMAZON : REVIEW_LENGTH_MAX;

  const disabledNext = !reviewLengthCheck(
    reviewTitle,
    reviewText,
    maxReviewLength
  );
  return (
    <FlowContainer
      sx={(theme) => ({ background: theme.vars.palette.common.white })}
    >
      <ReviewQuestionContainer>
        <ReviewInfo>
          <ProductHeader product={product} />
          <ReviewTitle sx={{ width: "100%" }}>
            Let’s start your product review.
          </ReviewTitle>
          <ReviewSection sx={{ flex: 1 }}>
            <ReviewLabel htmlFor="low-rating-title">Title</ReviewLabel>
            <TextInputBox
              id="low-rating-title"
              single
              value={reviewTitle}
              onChange={(e) => setReviewTitle(e.target.value)}
              aria-describedby="low-rating-characters-limit"
            ></TextInputBox>
            <AnimatePresence mode="wait">
              <CharactersLimit
                id="low-rating-title-characters-limit"
                text={reviewTitle}
                minLength={TITLE_LENGTH_MIN}
                maxLength={TITLE_LENGTH_MAX}
              />
            </AnimatePresence>
            <ReviewLabel htmlFor="low-rating-review">Review</ReviewLabel>
            <TextAreaInputBox
              value={reviewText}
              id="low-rating-review"
              aria-describedby="low-rating-review-characters-limit"
              onChange={(e) => setReviewText(e.target.value)}
            ></TextAreaInputBox>
            <AnimatePresence mode="wait">
              <CharactersLimit
                id="low-rating-review-characters-limit"
                text={reviewText}
                minLength={REVIEW_LENGTH_MIN}
                maxLength={maxReviewLength}
              />
            </AnimatePresence>
          </ReviewSection>
        </ReviewInfo>
        <FlowActionButtonsGroup>
          <FlowSolidButtonGrey onClick={moveBack}>Back</FlowSolidButtonGrey>
          <FlowSolidButton disabled={disabledNext} onClick={moveNext}>
            Next
          </FlowSolidButton>
        </FlowActionButtonsGroup>
      </ReviewQuestionContainer>
    </FlowContainer>
  );
};

export default LowRatingInput;
